import ButtonNav from "components/ButtonNav"
import React from "react"

function CategoryNavBar({ activeTab, setSelectedChallengeCategory, navBarList }) {
  function handleButtonNav(item) {
    setSelectedChallengeCategory(item)
  }

  return navBarList?.map((item, i) => {
    return (
      <ButtonNav
        style={{
          marginRight: 12,
          marginTop: 12
        }}
        onPress={() => handleButtonNav(item)}
        key={i}
        isActive={activeTab === item.id ? true : false}>
        {item.name}
      </ButtonNav>
    )
  })
}

export default CategoryNavBar
